import { Chip } from '../../../../core/components/atoms/Chip';

interface CourseTagsProps {
  tags: string[];
}

const CourseTags = ({ tags }: CourseTagsProps) => {
  const uniqueTags = tags.filter((value, index) => {
    return tags.indexOf(value) === index;
  });

  return (
    <div className='flex flex-wrap gap-sm'>
      {uniqueTags.map((tag, index) => (
        <Chip key={index} variant='negative' radius='pill'>
          {tag}
        </Chip>
      ))}
    </div>
  );
};

export default CourseTags;
